export const activeDropdownSelector = state => state.general.activeDropdown;
export const selectedAddressLocationSelector = state => state.general.selectedAddressLocation;
export const basemapSelector = state => state.general.basemap;
